import Col from '../grid/col';

export default Col;
export type { ColProps, ColSize } from '../grid/types';
